import { ActionTree } from "vuex";
import { CameraImageActionsTypes, CameraImageMutationsTypes } from "./types";
import { CameraImage, CameraImageActions, CameraImageState, GetDevice } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<CameraImageState, CameraImageState> & CameraImageActions = {
  [CameraImageActionsTypes.LIST_CAMERA_IMAGE]: async ({ commit }): Promise<void> => {
    const last_update = sessionStorage.getItem("last_update") ?? "";
    return Client.get<number, Response_>(`camera_image/list?last_update=${last_update}`)
      .then((response: Response_) => {
        commit(CameraImageMutationsTypes.SET_CAMERA_IMAGE, response.body as Array<CameraImage>);
        return response.status;
      })
      .catch((err) => err);
  },
  [CameraImageActionsTypes.GET_CAMERA_IMAGE]: async ({ commit }, info: GetDevice): Promise<void> => {
    return Client.get<number, Response_>(
      `camera_image/get/${info.id}/${info.number_devices ? info.number_devices : 14}`
    )
      .then((response: Response_) => {
        commit(CameraImageMutationsTypes.SET_CAMERA_IMAGE, response.body as Array<CameraImage>);
        return response.status;
      })
      .catch((err) => err);
  },
  [CameraImageActionsTypes.DOWNLOAD_CAMERA_IMAGE_ZIP]: async ({ commit }): Promise<string> => {
    return Client.get<number, Response_>(`camera_image/zip`)
      .then((response: Response_) => {
        return response.body;
      })
      .catch((err) => err);
  }
};
